// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1566":"e2ff2052860308e9","2333":"daa4a59d3f1a9552","2416":"601ab718dcb26838","3242":"c9f44ae52a0df961","8071":"eba01e7abdebd333","9709":"c3078be9a8d8cb6c","9915":"71247503775e05d4"}[chunkId] + ".js";
};